import PullQuoteEmbed from './pullQuoteEmbed.component';

export default PullQuoteEmbed;
